export default "__VITE_ASSET__DfH_MgCl__"